import * as React from "react";
import { Edit, EditButton, DeleteButton, SimpleForm, TextInput, BooleanInput, BooleanField, required, email, Toolbar, SaveButton, TextField, Datagrid, List, Create } from 'react-admin';

const PayrollEmailsEditToolbar = props => (
    <Toolbar {...props}>
        <SaveButton />
    </Toolbar>
);

const PayrollEmailTitle = props => {
    return <span>{Object.keys(props.record).length === 0 ? 'New Payroll Email' : props.record.email}</span>;
};

export const ProductionPayrollEmailsList = props => (
    <List {...props} title="Payroll Emails">
        <Datagrid rowClick="edit">
            <TextField source="email" label="Email Address" sortable={false} />
            <BooleanField source="is_reply_to" label="Reply-To" sortable={false} />
            <EditButton />
            <DeleteButton />
        </Datagrid>
    </List>
);

export const ProductionPayrollEmailsEdit = props => (
    <Edit {...props} title={<PayrollEmailTitle />} undoable={false}>
        <SimpleForm toolbar={<PayrollEmailsEditToolbar />} redirect="list">
            <TextInput source="email" label="Email Address" validate={[required(), email()]} />
            <BooleanInput source="is_reply_to" label="Use as reply-to address" />
        </SimpleForm>
    </Edit>
);

export const ProductionPayrollEmailsCreate = props => {
    const transform = data => {
        data.production_id = props.match.params.productionId;
        return data;
    };

    return <Create {...props} title={<PayrollEmailTitle />} transform={transform}>
        <SimpleForm toolbar={<PayrollEmailsEditToolbar />} redirect="list">
            <TextInput source="email" label="Email Address" validate={[required(), email()]} />
            <BooleanInput source="is_reply_to" label="Use as reply-to address" />
        </SimpleForm>
    </Create>
};
